/* eslint no-param-reassign: "off" */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import City from '../../types/City';

interface State {
  ids: number[];
  values: Record<number, City>;
}

const initialState: State = {
  ids: [],
  values: {},
};

const citiesSlice = createSlice({
  name: 'cities',
  initialState,
  reducers: {
    addCity: (state, action: PayloadAction<City>) => {
      const { id } = action.payload;
      state.ids.push(id);
      state.values[id] = action.payload;
    },

    updateCity: (state, action: PayloadAction<City>) => {
      const { id } = action.payload;
      state.values[id] = action.payload;
    },

    deleteCity: (state, action: PayloadAction<number>) => {
      const id = action.payload;
      state.ids.splice(state.ids.indexOf(id), 1);
      delete state.values[id];
    },

    setAllCities: (state, action: PayloadAction<City[]>) => {
      state.ids = [];
      state.values = {};

      action.payload.forEach((value) => {
        const { id } = value;
        state.ids.push(id);
        state.values[id] = value;
      });
    },
  },
});

export const selectCities = (state: any): Record<number, City> =>
  state.cities.values;

export const { setAllCities, addCity, updateCity, deleteCity } =
  citiesSlice.actions;
export default citiesSlice.reducer;
